import Body from "../Content/Body";
import { Paragraph } from "../../typography";
import Row from "../../lists/Row";
import { DataTableStyles } from "./dataTable.styles";

// Floor width (px) for a flex ("1") column when the table scrolls on mobile.
const FLEX_COLUMN_MIN = 160;

const DataTable = ({
  columns,
  data,
  renderRow,
  emptyMessage = "No items found",
  className,
  rowClassName,
  disableHover
}) => {
  // Derive the table's min-width from its columns (fixed widths + a floor for
  // the flex column + the head/row horizontal padding) so on mobile the table
  // scrolls horizontally instead of crushing the flex column to nothing. Passed
  // as a CSS var so it only takes effect inside the mobile media query.
  const minWidth =
    columns.reduce(
      (sum, col) =>
        sum +
        (col.width === "1" ? FLEX_COLUMN_MIN : parseInt(col.width, 10) || 0),
      0
    ) + 48;

  return (
    <DataTableStyles
      className={className}
      $disableHover={disableHover}
      style={{ "--dt-min-width": `${minWidth}px` }}
    >
      <Body className="dataTable-head">
      {columns.map(({ className: colClass, title, width }, i) => (
        <Paragraph
          className={`dataTable-headCell ${colClass}`}
          style={width === "1" ? { flex: 1 } : { width }}
          key={i}
        >
          {title}
        </Paragraph>
      ))}
    </Body>
    {data.length === 0 ? (
      <div className="dataTable-empty">{emptyMessage}</div>
    ) : (
      data.map((item, i) => (
        <Row
          key={item.id || i}
          className={typeof rowClassName === "function" ? rowClassName(item, i) : rowClassName}
        >
          {renderRow(item, i)}
        </Row>
      ))
    )}
    </DataTableStyles>
  );
};

export default DataTable;
